import Modal from 'antd/es/modal/Modal';
import React, { useEffect, useState } from 'react'
import styles from './Dashboard.module.scss';
import DashboardImgs from '../../util/Images';
import { Button, Form, Radio, Tag } from 'antd';
import { updateAsset } from '../../api/marketplace';

interface ListingTypeModalProps {
  open: boolean; 
  closeModal: () => void;  
  itemDetails: any;
  onUpdateSuccess?: () => void;
}

function ListingTypeModal({open, itemDetails, closeModal, onUpdateSuccess}:ListingTypeModalProps ) {
  
  const [listType, setListType] = useState<string>("Public");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if(itemDetails){
      setListType(itemDetails?.listing || "Public")
    }}, [itemDetails])

    const onUpdateListing = async(id:any) => {
      setLoading(true);
      try {
        await updateAsset(id, {visibility: listType})
        onUpdateSuccess?.();
        closeModal();
      } catch (error) {
        console.error('Error updating listing:', error);
      } finally {
        setLoading(false);
      }
    }

  return (
    <Modal
        centered
        open={open}
        onCancel={closeModal}
        width={1000}
        className={styles.list_type_modal}
        footer={false}
    >
         <h2>Product Review</h2> 
         <h5>{itemDetails?.productName}</h5>
         <section className={styles.item_box} >
          <div className={styles.asset_bg} >
            <img src={itemDetails?.assetImage || DashboardImgs.WhiteShirt}/>
          </div>
          <div className={styles.asset_details}>
            <small>Price</small>
            <span className={styles.label}>$ {itemDetails?.marketplaceData?.purchasePrice}</span>

            <small>Category</small>
            <span className={styles.label}>{itemDetails?.category}</span>

            <small>Creator </small>
            <span className={styles.label}>
              <Tag color={`#DCFCE7`} style={{ color: "#166534" }} >Synergetics <img src={DashboardImgs.GreenBatch} /></Tag>
             </span>
            

            <small>Designed For </small>
            <span className={styles.label}>Digital Twins Only</span>

            <small>Description </small>
            <p>{itemDetails?.marketplaceData?.description}</p>
            
          </div>
         </section>
         <hr/>
         <h5>Listing</h5>
         <div> 
          <Form layout="horizontal">
            <Form.Item name={"listing"} initialValue={itemDetails?.marketplaceData?.visibility}>
              <Radio.Group onChange={(e) => setListType(e.target.value)} value={listType} >
                <Radio value="public">Public</Radio>
                <Radio value="private">Private</Radio>
                {/* <Radio value="unlisted">Unlisted</Radio> */}
              </Radio.Group>
            </Form.Item>
          </Form>
          <div className={styles.submit_btn_row}>
            <Button className={styles.submit_btn} type="primary" onClick={()=> onUpdateListing(itemDetails.marketplaceData?._id )} loading={loading} disabled={loading}>
                Submit
            </Button>
          </div>
          
         </div>
    </Modal>
  )
}

export default ListingTypeModal